import { lazy } from "react";
// Clinical Notes List — listado de notas clínicas (generación previa a
// clinical-notes-v2, todavía expuesta en el menú Tools).
const ClinicalNotesList = lazy(() => import("./ClinicalNotesList"));
export const clinicalNotesListRoutes = [
  { path: "/ClinicalNotesList", element: <ClinicalNotesList /> },
];

export { ClinicalNotesList };
